import React from 'react';
import PageTitle from '../components/PageTitle';
import TrustedClients from '../components/TrustedClients';

const ClientsPage = () => {
    return (
        <div className="bg-white text-gray-800">
            {/* Hero Section */}
            <PageTitle
                title="Our Clients"
                breadcrumbs="Home / Clients"
            />

            {/* Full Clients Section with Grid Layout */}
            <TrustedClients
                theme="light"
                variant="grid"
                showStats={true}
            />

            {/* Additional Section - Why Companies Trust Us */}
            <section className="py-20 bg-gray-800">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center mb-16">
                        <div className="inline-flex items-center space-x-2 mb-6">
                            <div className="h-0.5 w-8 bg-yellow-500"></div>
                            <span className="text-yellow-500 font-medium tracking-wider uppercase text-sm">
                                Why Choose Us
                            </span>
                            <div className="h-0.5 w-8 bg-yellow-500"></div>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                            Why Industry Leaders Trust Jiotronik
                        </h2>
                        <p className="text-lg text-gray-300">
                            We deliver excellence in every project, building relationships that last beyond deliverables
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            {
                                icon: '🏆',
                                title: 'Proven Track Record',
                                desc: 'Years of successful implementations across diverse industries from education to manufacturing.'
                            },
                            {
                                icon: '🔧',
                                title: 'Technical Excellence',
                                desc: 'Our engineering team brings deep expertise in automation, electronics, and smart solutions.'
                            },
                            {
                                icon: '🤝',
                                title: 'Partnership Approach',
                                desc: 'We work as an extension of your team, understanding your unique challenges and goals.'
                            },
                            {
                                icon: '⚡',
                                title: 'Rapid Response',
                                desc: '24/7 support and emergency services ensure your operations never face downtime.'
                            },
                            {
                                icon: '🎯',
                                title: 'Custom Solutions',
                                desc: 'Tailored designs that precisely match your requirements, not one-size-fits-all approaches.'
                            },
                            {
                                icon: '📈',
                                title: 'Continuous Improvement',
                                desc: 'We help optimize and upgrade your systems as technology and needs evolve.'
                            }
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="group bg-gray-700/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-600 hover:border-yellow-500/30 transition-all duration-500"
                            >
                                <div className="text-4xl mb-4">{item.icon}</div>
                                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-yellow-500 transition-colors">
                                    {item.title}
                                </h3>
                                <p className="text-gray-400">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-16 bg-yellow-500">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Ready to Join Our Success Stories?
                    </h2>
                    <p className="text-gray-700 mb-8 max-w-2xl mx-auto">
                        Partner with Jiotronik and experience the difference that expertise and dedication make.
                    </p>
                    <a
                        href="/contact"
                        className="inline-block bg-gray-900 hover:bg-gray-800 text-white font-bold px-10 py-4 rounded-lg text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                    >
                        Get in Touch
                    </a>
                </div>
            </section>
        </div>
    );
};

export default ClientsPage;
